/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import styles from './input.style.module.css';

const Input = ({
    id,
    label,
    value,
    isDisabled,
    isMultiline = false,
    handleChange = () => { },
    handleClick = () => { },
    readOnly = false,
    isError = false,
    endAdornment = null,
    fullWidth = false,
    inputType = 'text',
    ...restProps
}) => {
    const [inputValue, setInputValue] = useState(value || '');

    useEffect(() => {
        setInputValue(value);
    }, [value]);

    const onChange = ({ target: { value: onChangeValue } }) => {
        setInputValue(onChangeValue);
        handleChange(onChangeValue);
    };

    const onClick = () => {
        handleClick();
    };

    return (
        <TextField
            type={inputType}
            size="small"
            error={isError}
            multiline={isMultiline}
            disabled={isDisabled}
            id={id}
            label={label}
            FormHelperTextProps={{ sx: { marginLeft: 0 } }}
            variant="outlined"
            className={`mt-4 ${styles.input}`}
            value={inputValue}
            onChange={onChange}
            onClick={onClick}
            fullWidth={fullWidth}
            InputProps={{
                readOnly,
                endAdornment
            }}
            {...restProps}
        />
    );
};

Input.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    isDisabled: PropTypes.bool,
    handleChange: PropTypes.func
};

export default Input;
